var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoTimes = function SvgIcoTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.21 356.07a31.46 31.46 0 0 0 0 44.48l22.24 22.24a31.46 31.46 0 0 0 44.48 0L176 322.72 109.28 256Zm333.58-244.62-22.24-22.24a31.46 31.46 0 0 0-44.48 0L176 189.28 242.72 256l100.07-100.07a31.46 31.46 0 0 0 0-44.48",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.79 356.07a31.46 31.46 0 0 1 0 44.48l-22.24 22.24a31.46 31.46 0 0 1-44.48 0L9.21 155.93a31.46 31.46 0 0 1 0-44.48l22.24-22.24a31.46 31.46 0 0 1 44.48 0Z",
    className: "ico-times_svg__fa-primary"
  })));
};
export default SvgIcoTimes;